var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72953 7.875C2.26562 7.875 1 6.75 1 4.78125V1.96875H3.53125",
    stroke: "#111111",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6561 1.96875H16.1874V4.78125C16.1874 6.75 14.9217 7.875 13.4592 7.875",
    stroke: "#111111",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 14.9062V12.9375",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 11.5312C7.25109 11.5312 5.96342 10.9979 5.01402 10.0485C4.06462 9.09907 3.53125 7.81141 3.53125 6.46875V0.84375H13.6562V6.46875C13.6562 7.81141 13.1229 9.09907 12.1735 10.0485C11.2241 10.9979 9.93641 11.5312 8.59375 11.5312V11.5312Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65625 17.1562C4.65625 15.9137 5.5 14.9062 7.46875 14.9062H9.71875C11.6875 14.9062 12.5312 15.9137 12.5312 17.1562H4.65625Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73828 5.65625H8.33984C8.6263 5.65625 8.83854 5.58464 8.97656 5.44141C9.11458 5.29818 9.18359 5.10807 9.18359 4.87109C9.18359 4.64193 9.11458 4.46354 8.97656 4.33594C8.84115 4.20833 8.65365 4.14453 8.41406 4.14453C8.19792 4.14453 8.01693 4.20443 7.87109 4.32422C7.72526 4.44141 7.65234 4.59505 7.65234 4.78516H6.52344C6.52344 4.48828 6.60286 4.22266 6.76172 3.98828C6.92318 3.7513 7.14714 3.56641 7.43359 3.43359C7.72266 3.30078 8.04036 3.23438 8.38672 3.23438C8.98828 3.23438 9.45964 3.37891 9.80078 3.66797C10.1419 3.95443 10.3125 4.35026 10.3125 4.85547C10.3125 5.11589 10.2331 5.35547 10.0742 5.57422C9.91536 5.79297 9.70703 5.96094 9.44922 6.07812C9.76953 6.19271 10.0078 6.36458 10.1641 6.59375C10.3229 6.82292 10.4023 7.09375 10.4023 7.40625C10.4023 7.91146 10.2174 8.31641 9.84766 8.62109C9.48047 8.92578 8.99349 9.07812 8.38672 9.07812C7.81901 9.07812 7.35417 8.92839 6.99219 8.62891C6.63281 8.32943 6.45312 7.93359 6.45312 7.44141H7.58203C7.58203 7.65495 7.66146 7.82943 7.82031 7.96484C7.98177 8.10026 8.17969 8.16797 8.41406 8.16797C8.68229 8.16797 8.89193 8.09766 9.04297 7.95703C9.19661 7.8138 9.27344 7.625 9.27344 7.39062C9.27344 6.82292 8.96094 6.53906 8.33594 6.53906H7.73828V5.65625Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy3);
export default ForwardRef;